import React, { useState, useCallback } from "react";
import classnames from "classnames";
import { makeStyles, createStyles } from "@material-ui/core";
import { ISeatInfo } from "../../interface/IShareInfo";
import { Text } from "../Ui/Text";

interface IProps {
  seatInfo: ISeatInfo | undefined;
  loading: boolean;
}

const useStyles = makeStyles(({ palette }) => {
  return createStyles({
    rowContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%"
    },

    headingRowContainer: {
      paddingTop: 10
    },

    textWrapper: {
      width: "33.33%",
      display: "flex",
      justifyContent: "center"
    },
    text: {
      textTransform: "uppercase",
      fontWeight: "bold",
      color: "#fff"
    },
    labelText: {
      opacity: 0.5,
      fontSize: "1.4rem"
    },
    contentText: {
      textAlign: "center",
      fontSize: "2.4rem"
    }
  });
});

const SeatInfoComponent = ({ seatInfo, loading }: IProps) => {
  const classes = useStyles({});

  return (
    <React.Fragment>
      <div
        className={classnames(
          classes.headingRowContainer,
          classes.rowContainer
        )}
      >
        <Text
          variant="body1"
          wrapperClassName={classes.textWrapper}
          className={classnames(classes.text, classes.labelText)}
        >
          Section
        </Text>
        <Text
          variant="body1"
          wrapperClassName={classes.textWrapper}
          className={classnames(classes.text, classes.labelText)}
        >
          Row
        </Text>
        <Text
          variant="body1"
          wrapperClassName={classes.textWrapper}
          className={classnames(classes.text, classes.labelText)}
        >
          Seat
        </Text>
      </div>
      <div className={classes.rowContainer}>
        <Text
          variant="body1"
          wrapperClassName={classes.textWrapper}
          className={classnames(classes.text, classes.contentText)}
        >
          {seatInfo ? seatInfo.sectionNumber : ""}
        </Text>
        <Text
          variant="body1"
          wrapperClassName={classes.textWrapper}
          className={classnames(classes.text, classes.contentText)}
        >
          {seatInfo ? seatInfo.rowNumber : ""}
        </Text>
        <Text
          variant="body1"
          wrapperClassName={classes.textWrapper}
          className={classnames(classes.text, classes.contentText)}
        >
          {seatInfo ? seatInfo.seatNumber : ""}
        </Text>
      </div>
    </React.Fragment>
  );
};

export const SeatInfo = SeatInfoComponent;
